import { api } from './api';

export const weatherService = {
  getPollen: async () => {
    try {
      return await api.get('/api/weather/pollen');
    } catch (error) {
      console.error('Error fetching pollen data:', error);
      throw error;
    }
  },

  getPollenDefault: async () => {
    try {
      return await api.get('/api/weather/pollen');
    } catch (error) {
      console.error('Error fetching default pollen data:', error);
      throw error;
    }
  },

  getPollenWithCoords: async (lat, lon) => {
    try {
      return await api.get(`/api/weather/pollen?lat=${lat}&lon=${lon}`);
    } catch (error) {
      console.error('Error fetching pollen data with coords:', error);
      throw error;
    }
  },

  getPollenByRegion: async (regionKey) => {
    try {
      return await api.get(`/api/weather/pollen?region=${regionKey}`);
    } catch (error) {
      console.error('Error fetching pollen data by region:', error);
      throw error;
    }
  },

  getHumidity: async () => {
    try {
      return await api.get('/api/weather/humidity');
    } catch (error) {
      console.error('Error fetching humidity data:', error);
      throw error;
    }
  }
};
